import { useState } from 'react';

const faqItems = [
  {
    id: 1,
    q: '星空电影网真的不需要缓冲等待吗？',
    a: '是的，我们的核心技术就是智能预加载引擎。在你观看当前片段时，系统已经在后台预加载下一段内容，确保播放过程真正实现零缓冲秒开。经过大量用户实测，99.7%的播放请求都能做到即点即播。即便是4K超清画质，也能保持流畅无卡顿。',
  },
  {
    id: 2,
    q: '需要注册账号或者付费才能观看吗？',
    a: '完全不需要。星空电影网始终坚持免费在线观看的理念，无需注册、无需登录、无需付费。打开网页选择你想看的电影，点击播放即可。我们通过技术优化降低运营成本，让每一位影迷都能无门槛享受高清观影体验。',
  },
  {
    id: 3,
    q: '支持哪些设备观看？画质最高支持到什么级别？',
    a: '全面支持桌面电脑、平板和手机端，网页自适应不同屏幕尺寸。画质方面，大多数片源提供1080P高清，热门新片及经典修复版支持4K超清分辨率。系统会根据你的网络环境自动调节最适合的码率，确保流畅播放。',
  },
  {
    id: 4,
    q: '片源更新频率怎么样？最新电影什么时候上线？',
    a: '我们保持每日更新的节奏，每天都有新片源加入片库。节假日和周末会有专题批量更新。对于热门院线影片，通常在下映后1-2个月内就能看到高清版本上线。每周五晚是我们的固定大更新时间，建议收藏关注。',
  },
  {
    id: 5,
    q: '播放过程中遇到卡顿该怎么办？',
    a: '首先可以尝试在播放器中手动降低一档画质（从4K切换到1080P），通常能解决因网络波动引起的卡顿。如果问题持续，建议刷新页面重新加载。我们的CDN节点会自动切换最优线路。极少数情况下可能是片源本身问题，欢迎通过联系页面反馈。',
  },
];

export default function FaqSection() {
  const [openId, setOpenId] = useState<number>(1);

  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50 mb-3">
            常见问题
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            关于观影体验的常见疑问，这里都有解答
          </p>
        </div>

        <div className="max-w-2xl mx-auto space-y-3">
          {faqItems.map((item) => (
            <div
              key={item.id}
              className="bg-background-100/80 rounded-lg border border-background-200/50 overflow-hidden"
            >
              <button
                onClick={() => setOpenId(openId === item.id ? 0 : item.id)}
                className="w-full flex items-center justify-between p-4 md:p-5 text-left cursor-pointer hover:bg-background-200/30 transition-colors"
              >
                <h3 className="text-sm font-semibold text-foreground-200 pr-4">{item.q}</h3>
                <span className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                  <i
                    className={`text-foreground-500 text-sm transition-transform duration-200 ${
                      openId === item.id ? 'ri-subtract-line' : 'ri-add-line'
                    }`}
                  ></i>
                </span>
              </button>
              {openId === item.id && (
                <div className="px-4 md:px-5 pb-4 md:pb-5">
                  <p className="text-sm text-foreground-400 leading-relaxed border-t border-background-200/40 pt-4">
                    {item.a}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}